import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject;

import * as React from "react";
import { UniversalLink } from "../UniversalLink/UniversalLink";
import { Footer, FooterSeparator, FooterCopyright, ColumnTitle, ColumnList, ColumnListItem, FooterInfo } from "./footer.elements";
import styled from "../../styled-components";
import { Box, Flex } from "@redocly/developer-portal/ui";
import { mediaCSS } from "@redocly/reference-docs";
var StyledFooter = styled.footer(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  font-size: 1rem;\n  flex-shrink: 0;\n  ", "\n\n  @media print {\n    color: black;\n    ", " {\n      display: none;\n    }\n  }\n"])), function (_ref) {
  var a = _ref.theme;
  return mediaCSS({
    fontFamily: a.typography.fontFamily
  });
}, Footer);

var UserFooter = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(UserFooter, _React$PureComponent);

  function UserFooter() {
    return _React$PureComponent.apply(this, arguments) || this;
  }

  var _proto = UserFooter.prototype;

  _proto.render = function render() {
    var _this$props$footer = this.props.footer,
        a = _this$props$footer.columns,
        b = _this$props$footer.copyrightText,
        c = this.props.siteVersion,
        d = a.length ? /*#__PURE__*/React.createElement(Footer, {
      justifyContent: "center",
      flexWrap: "wrap",
      flex: "1",
      p: {
        xs: "3em 0 1em 0",
        small: "5.625em 0 3.9375em 0"
      }
    }, /*#__PURE__*/React.createElement(Flex, {
      justifyContent: "center",
      flexDirection: {
        xs: "column",
        small: "row"
      },
      flexWrap: {
        small: "wrap"
      },
      maxWidth: "1200px",
      flex: {
        small: "1 1 100%"
      },
      px: "20px"
    }, a.map(function (a, b) {
      return /*#__PURE__*/React.createElement(Box, {
        key: b,
        textAlign: {
          xs: "center",
          small: "left"
        },
        mb: {
          xs: "4em",
          small: "3em",
          medium: 0
        },
        flex: {
          xs: "0 calc(50% - 20px)",
          small: "0 calc(33.333% - 20px)",
          medium: 1
        },
        mx: 10
      }, /*#__PURE__*/React.createElement(ColumnTitle, null, a.group || a.label), /*#__PURE__*/React.createElement(ColumnList, null, a.items.map(function (a, b) {
        return "separator" === a.type ? /*#__PURE__*/React.createElement(FooterSeparator, {
          key: a.label + "_" + b
        }, a.label) : /*#__PURE__*/React.createElement(ColumnListItem, {
          key: b
        }, /*#__PURE__*/React.createElement(UniversalLink, {
          to: a.link,
          target: a.target,
          external: a.external,
          "data-cy": a.label
        }, a.label));
      })));
    }))) : null,
        e = b || c ? /*#__PURE__*/React.createElement(FooterInfo, null, /*#__PURE__*/React.createElement(FooterCopyright, null, b, " ", c ? "| " + c : null)) : null;
    return /*#__PURE__*/React.createElement(StyledFooter, null, d, e);
  };

  return UserFooter;
}(React.PureComponent);

export { UserFooter as default };